// 财产日志类型
export const CAPITAL_TYPE = [
    {
        id: 15,
        title: '客服系统'
    },
    {
        id: 14,
        title: '后台操作'
    },
    {
        id: 13,
        title: '上上级提成'
    },
    {
        id: 12,
        title: '绑定奖励'
    },
    {
        id: 11,
        title: '注册奖励'
    },
    {
        id: 10,
        title: '邀请奖励'
    },
    {
        id: 9,
        title: '提现'
    },
    {
        id: 8,
        title: '签到'
    },
    {
        id: 7,
        title: '群主返利'
    },
    {
        id: 6,
        title: '上级奖励'
    },
    {
        id: 5,
        title: '订单返利'
    },
    {
        id: 4,
        title: '积分'
    },
    {
        id: 3,
        title: '首单奖励'
    },
    {
        id: 2,
        title: '任务奖励'
    },
    {
        id: 1,
        title: '进阶奖励'
    }
]